import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/network/intro',
            name: 'network_intro',
            component: () => import("./views/intro.vue"),
            meta: {
                hasBar: true
            }
        },
    ];
};